const CURRENCY_SYMBOLS = {
    UAH: '₴',
    USD: '$',
    EUR: '€',
    MDL: 'L',
};
export function formatPrice(price, currency, negotiableLabel) {
    if (price === null)
        return negotiableLabel;
    const symbol = CURRENCY_SYMBOLS[currency];
    return `${price.toLocaleString('uk-UA')} ${symbol}`;
}
//# sourceMappingURL=format.js.map